import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutesEnum } from '@shared/types';
import { ButtonComponent } from '@ui-kit/buttons';

@Component({
    selector: 'app-error-page',
    standalone: true,
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    imports: [TranslateModule, ButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
    private router = inject(Router);

    private readonly urls = AppRoutesEnum;

    goToDashboard(): void {
        if (this.router.url.toLowerCase().includes(this.urls.DASHBOARD)) {
            this.router.navigate([AppRoutesEnum.DASHBOARD]).then(() => {
                window.location.reload();
            });
        } else {
            this.router.navigate([AppRoutesEnum.DASHBOARD]);
        }
    }

    openChat(): void {
        // @ts-expect-error -- window is not typed
        window['happyFoxChat'].showWidget();
        // @ts-expect-error -- window is not typed
        window['happyFoxChat'].expandChatbox();
    }
}
